import React from "react";

import { useTranslation } from "react-i18next";

import { Button } from "../../../../../../../../../components/Form";
import { Color } from "../../../../../../../../../components/Form/Button";
import { FooterContainer } from "./styles";

type Props = {
  onSave: () => void;
  onCancel: () => void;
  isLoading: boolean;
  isShowSave: boolean;
};

const EquipmentEditFooter: React.FC<Props> = ({ onSave, onCancel, isLoading, isShowSave }) => {
  const { t: translate } = useTranslation();

  return (
    <FooterContainer>
      <Button customColor={Color.CANCEL} disabled={isLoading} onClick={onCancel}>
        {translate("cancel")}
      </Button>
      {isShowSave && (
        <Button
          customColor={Color.SUCCESS}
          loading={isLoading}
          disabled={isLoading}
          onClick={onSave}
        >
          {translate("save")}
        </Button>
      )}
    </FooterContainer>
  );
};

export default EquipmentEditFooter;
